import { fetch } from '@atlassian/eoc-fetch';
import type { ScheduleEntity } from '@atlassian/eoc-schedule-common/types';
import type {
	DeleteScheduleParameters,
	UpdateScheduleParameters,
	UpdateScheduleResponse,
} from '@atlassian/eoc-schedule-common/types/schedule';

import { urls } from '../../../common/constants/urls';

import type { TeamScheduleListResponse } from './types';

const getScheduleList = (teamId: string): Promise<TeamScheduleListResponse> => {
	return fetch<TeamScheduleListResponse>(urls.schedules.teams.teamId.url({ teamId }));
};

const updateSchedule = ({
	scheduleId,
	description,
	name,
	enabled,
	timezone,
}: UpdateScheduleParameters): Promise<ScheduleEntity> => {
	return fetch<UpdateScheduleResponse>(urls.schedules.scheduleId.url({ scheduleId }), {
		method: 'PATCH',
		body: {
			description,
			name,
			enabled,
			timezone,
		},
	});
};

const deleteSchedule = ({ scheduleId }: DeleteScheduleParameters): Promise<{}> => {
	return fetch(urls.schedules.scheduleId.url({ scheduleId }), {
		method: 'DELETE',
	});
};

export const endpoints: {
	deleteSchedule: ({ scheduleId }: DeleteScheduleParameters) => Promise<{}>;
	getScheduleList: (teamId: string) => Promise<TeamScheduleListResponse>;
	updateSchedule: ({
		scheduleId,
		description,
		name,
		enabled,
		timezone,
	}: UpdateScheduleParameters) => Promise<ScheduleEntity>;
} = {
	deleteSchedule,
	getScheduleList,
	updateSchedule,
};
